/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Filter_ActionInputs */

const cs_audit_filter_action = /** @type {(inputs: Audit_Filter_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klíč akce`)
};

const en_audit_filter_action = /** @type {(inputs: Audit_Filter_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Action key`)
};

/**
* | output |
* | --- |
* | "Action key" |
*
* @param {Audit_Filter_ActionInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const audit_filter_action = /** @type {((inputs?: Audit_Filter_ActionInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Filter_ActionInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_audit_filter_action(inputs)
	return cs_audit_filter_action(inputs)
});